// This reducer is used in Booking Review Page also consider creating this an indepedent reducer
// when-ever we  convert checkout to V4
import { login } from 'actions/LoginSignupActions/loginActions';
import { signup, signupStatus } from 'actions/LoginSignupActions/signupActions';
import { generateLoginOTP } from 'actions/LoginSignupActions/generateLoginOtpActions';
import { updateIdentity, verifyIdentity } from 'actions/LoginSignupActions/updateIdentityActions';
import { setPassword } from 'actions/LoginSignupActions/setPasswordActions';
import { reactivateAccount } from 'actions/LoginSignupActions/reactivateAccountActions';
import { verifyOTP } from 'actions/LoginSignupActions/verifyLoginOtpActions';
import { LOADING, SUCCESS, ERROR, INIT } from 'utils/asyncStatusHelper';
export default function loginReducer(state = {
    asyncStatus: INIT
}, action) {
    switch (action.type) {
        case login.USER_LOGIN_REQUEST:
        case generateLoginOTP.USER_GENERATE_OTP:
        case verifyOTP.USER_VERIFY_OTP:
        case signup.USER_SIGN_UP_REQUEST:
        case signupStatus.USER_SIGN_UP_STATUS:
        case setPassword.USER_SET_PASSWORD_REQUEST:
        case updateIdentity.USER_UPDATE_IDENTITY_REQUEST:
        case reactivateAccount.REACTIVATE_USER_ACCOUNT_REQUEST:
        case verifyIdentity.VERIFY_USER_ACCOUNT_REQUEST:
            return { asyncStatus: LOADING };
        case login.USER_LOGIN_SUCCESS:
        case generateLoginOTP.USER_GENERATE_OTP_SUCCESS:
        case verifyOTP.USER_VERIFY_OTP_SUCCESS:
        case signup.USER_SIGN_UP_SUCCESS:
        case signupStatus.USER_SIGN_UP_STATUS_SUCCESS:
        case setPassword.USER_SET_PASSWORD_SUCCESS:
        case updateIdentity.USER_UPDATE_IDENTITY_SUCCESS:
        case reactivateAccount.REACTIVATE_USER_ACCOUNT_SUCCESS:
        case verifyIdentity.VERIFY_USER_ACCOUNT_SUCCESS:
            return { asyncStatus: SUCCESS };
        case login.USER_LOGIN_ERROR:
        case generateLoginOTP.USER_GENERATE_OTP_ERROR:
        case verifyOTP.USER_VERIFY_OTP_ERROR:
        case signup.USER_SIGN_UP_ERROR:
        case signupStatus.USER_SIGN_UP_STATUS_ERROR:
        case setPassword.USER_SET_PASSWORD_ERROR:
        case updateIdentity.USER_UPDATE_IDENTITY_ERROR:
        case reactivateAccount.REACTIVATE_USER_ACCOUNT_ERROR:
        case verifyIdentity.VERIFY_USER_ACCOUNT_ERROR:
            return { asyncStatus: ERROR };
        default:
            return state;
    }
}
